export default "__VITE_ASSET__0b1e70c0__"